module.exports = __webpack_public_path__ + "static/img/exam_7.30ee6c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/exam_7.png
// module id = +Nzo
// module chunks = 1